import { render, staticRenderFns } from "./DonationDestination.vue?vue&type=template&id=4b37482a&"
import script from "./DonationDestination.vue?vue&type=script&lang=ts&"
export * from "./DonationDestination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/livingDonors/_locales/DonationDestination.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FlivingDonors%2FDonationDestination.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports